<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.periodLossReasonId"
          v-bind="getObject('periodLossReasonId')"
          label="Motivo da Perda em Ciclo"
          :items="extraData.accountContext.allPeriodLossReasons"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <PeriodLossReasonNew
              :inlineAddButton="true"
              @entry-created="periodLossReasonCreated"
              modelNameSingular="Motivo da Perda em Ciclo"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="8">
        <v-autocomplete
          v-model="entry.periodId"
          v-bind="getObject('periodId')"
          label="Ciclo"
          :items="extraData.accountContext.allPeriodsWithPlantingOpenned"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          @input="selectPeriod"
          :hint="entry.period ? entry.period.additionalInfo + (entry.period.secondAdditionalInfo ? ', ' + entry.period.secondAdditionalInfo : '') : '' "
          persistent-hint
          autocomplete="off"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title class="text-subtitle-1">{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>
                {{data.item.additionalInfo}}
                <br v-if="data.item.secondAdditionalInfo">
                {{data.item.secondAdditionalInfo}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="4">
        <DateField
          :inputData.sync="entry.date"
          v-bind="getObject('date')"
          label="Data do Ajuste"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.periodId">
        <PeriodLossItemsIndex
          :periodLossItems="entry.periodLossItemsAttributes"
          :periodLoss="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
        />
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Observações"
          outlined
          autocomplete="off"
          :disabled="readOnly"
        ></v-textarea>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue";
import PeriodLossItemsIndex from "@models/periods/period_losses/period_loss_items/index.vue";
import PeriodLossReasonNew from "@models/periods/period_losses/period_loss_reasons/new.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    PeriodLossItemsIndex: PeriodLossItemsIndex,
    PeriodLossReasonNew: PeriodLossReasonNew,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    if (this.entry.periodId) {
      let tem_period = this.extraData.accountContext.allPeriodsWithPlantingOpenned.find(obj => obj.id == this.entry.periodId);
      if (!tem_period && this.entry.period) {
        this.extraData.accountContext.allPeriodsWithPlantingOpenned.unshift(this.entry.period); 
      }
    }
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectPeriod: function() {
      this.entry.period = this.extraData.accountContext.allPeriodsWithPlantingOpenned.find(obj => obj.id == this.entry.periodId);
    },
    periodLossReasonCreated: function(periodLossReason) {
      this.extraData.accountContext.allPeriodLossReasons.unshift(periodLossReason);
      this.entry.periodLossReasonId = periodLossReason.id;
      this.entry.periodLossReason = periodLossReason;
    },
  }
};
</script>

<style scoped></style>
